// =============================================================================
// IdentificaVendedor — "de quem é esta venda?"
//
// É a primeira coisa que aparece ao iniciar um orçamento, porque é a primeira
// coisa que o ERP quer saber. A senha do vendedor não é um segundo login: ela
// diz DE QUEM É A VENDA — e é isso que define a comissão.
//
// A senha identifica o vendedor sozinha (231 vendedores, 231 senhas distintas),
// então não há lista de nomes para escolher: digita e o sistema reconhece.
// =============================================================================

import { useState } from 'react';
import api, { setCracha, lembrarCrachaDev, mensagemDeErro } from '../services/api';

export default function IdentificaVendedor({ aoIdentificar }) {
  const [senha, setSenha] = useState('');
  const [codigo, setCodigo] = useState('');
  const [exigeCodigo, setExigeCodigo] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function enviar(e) {
    e.preventDefault();
    if (carregando || !senha.trim()) return;
    setCarregando(true);
    setErro('');
    try {
      const { data } = await api.post('/api/vendedor/identificar', {
        senha: senha.trim(),
        codvend: exigeCodigo ? codigo.trim() : undefined,
      });
      setCracha(data.cracha);
      lembrarCrachaDev(data.vendedor, data.cracha);   // só no dev
      aoIdentificar(data.vendedor);
    } catch (err) {
      if (err.response?.data?.exige_codigo) setExigeCodigo(true);
      setErro(mensagemDeErro(err, 'Não foi possível identificar o vendedor.'));
      setSenha('');
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="d-flex justify-content-center" style={{ paddingTop: '6vh' }}>
      <div className="card" style={{ maxWidth: 420, width: '100%' }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <div className="d-inline-flex align-items-center justify-content-center mb-3"
                 style={{ width: 60, height: 60, borderRadius: 16,
                          background: 'var(--primary-light)', color: 'var(--primary)', fontSize: '1.7rem' }}>
              <i className="bi bi-person-badge" />
            </div>
            <h2 className="h5 fw-bold mb-1">Quem está vendendo?</h2>
            <p className="text-muted small mb-0">
              Digite a senha do vendedor — a mesma que ele usa no Microuniverso.
              É ela que registra de quem é a venda.
            </p>
          </div>

          {erro && (
            <div className="alert alert-danger py-2 px-3 small d-flex align-items-start gap-2">
              <i className="bi bi-exclamation-triangle-fill mt-1" /><span>{erro}</span>
            </div>
          )}

          <form onSubmit={enviar}>
            {exigeCodigo && (
              <div className="mb-3">
                <label className="form-label small fw-semibold">Código do vendedor</label>
                <input className="form-control" inputMode="numeric" value={codigo} autoFocus
                       onChange={(e) => setCodigo(e.target.value)} placeholder="ex.: 123" />
              </div>
            )}
            <div className="mb-4">
              <label className="form-label small fw-semibold">Senha do vendedor</label>
              <input type="password" className="form-control form-control-lg text-center"
                     inputMode="numeric" autoComplete="off" value={senha} autoFocus={!exigeCodigo}
                     onChange={(e) => setSenha(e.target.value)}
                     placeholder="••••" style={{ letterSpacing: '0.4em' }} />
            </div>
            <button type="submit" className="btn btn-primary-fnx w-100 py-2 fw-semibold"
                    disabled={carregando || !senha.trim()}>
              {carregando
                ? (<><span className="spinner-border spinner-border-sm me-2" />Conferindo…</>)
                : (<><i className="bi bi-unlock me-2" />Começar orçamento</>)}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
